import React, { useState } from "react";
import { Button } from "../../../../../stories/Button/Button";
import classes from "./CancelLesson.module.css";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import { Checkbox } from "../../../../../stories/Checkbox/Checkbox";
import { TextArea } from "../../../../../stories/TextArea/TextArea";

const CancelLesson = ({ show, setShow }) => {
  const [cancelReason, setCancelReason] = useState();
  const [reason, setReason] = useState("");

  const cancelArray = [
    "Medical emergency",
    "Weather",
    "Other (nothing from the above)",
  ];

  return (
    <>
      <style>{`
            @media screen and (max-width: 580px) {
          .modal .modal-dialog {
            width: 80% !important;
            margin: 0px 10%;
          }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        headerStyles={{ marginBottom: "0px", paddingBottom: "24px" }}
        borderRadius={"20px"}
        footerStyles={{ padding: "16px 32px", margin: "0px" }}
        width={"509px"}
        header={
          <h4
            style={{
              ...Fonts.h4,
              fontSize: "26px",
              color: Colors.neutralShadesOfNero,
            }}
          >
            Cancel Lesson
          </h4>
        }
        footer={
          <div className={classes.footerBtns}>
            <Button
              label={"Cancel"}
              primary={false}
              customStyle={{
                width: "95px",
                marginRight: "20px",
                backgroundColor: Colors.white,
                border: "none",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
            />
            <Button
              label={"Submit"}
              primary={true}
              customStyle={{
                width: "120px",
                height: "48px",
                ...Fonts.b2,
                lineHeight: "20px",
              }}
            />
          </div>
        }
      >
        <div className={classes.modalContent}>
          {cancelArray?.map((item, i) => {
            return (
              <div className={[classes.mb16].join(" ")} key={i}>
                <Checkbox
                  label={`${item}`}
                  value={cancelReason}
                  setValue={setCancelReason}
                />
              </div>
            );
          })}
        </div>
        <div className={[classes.disclaimerSection].join(" ")}>
          {cancelReason?.includes("Other (nothing from the above)") ? (
            <TextArea
              placeholder={"Tell us more about why you can’t come..."}
              state={reason}
              setter={setReason}
            />
          ) : (
            <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
              <span style={{ ...Fonts.h7, color: Colors.errorColor }}>
                PLEASE NOTE!
              </span>{" "}
              Since less than 24 hours are left before the start of the lesson,{" "}
              <span style={{ ...Fonts.h7, color: Colors.neutralShadesOfNero }}>
                we will not be able to refund the payment.
              </span>
            </p>
          )}
        </div>
      </ModalSkeleton>
    </>
  );
};
export default CancelLesson;
